function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import isExternal from 'is-url-external';
import { Menu } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';

/**
 * Link that also works for external URLs
 */
var IntExtLinkHandler = function (_React$Component) {
  _inherits(IntExtLinkHandler, _React$Component);

  function IntExtLinkHandler() {
    _classCallCheck(this, IntExtLinkHandler);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  IntExtLinkHandler.prototype.render = function render() {
    var menuItem = this.props.menuItem;


    return isExternal('' + menuItem.url) ? React.createElement(
      'a',
      {
        href: menuItem.url,
        className: 'item nav-menu__nav-link ' + (menuItem.parent && menuItem.parent > 0 ? 'nav-menu__nav-link-child' : ''),
        'data-testid': 'link-external',
        target: menuItem.target
      },
      menuItem.title
    ) : React.createElement(Menu.Item, {
      as: NavLink,
      to: menuItem.url,
      target: menuItem.target,
      name: menuItem.title,
      className: 'nav-menu__nav-link ' + (menuItem.parent && menuItem.parent > 0 ? 'nav-menu__nav-link-child' : ''),
      activeClassName: 'nav-menu__nav-link--active',
      exact: true,
      'data-testid': 'link-internal'
    });
  };

  return IntExtLinkHandler;
}(React.Component);

export default IntExtLinkHandler;